import React from 'react';
import { makeStyles, createStyles, Box, Link } from '@mui/material';
import { Theme } from '@mui/material';
import { FuturePrice as IFuturePrice } from '../model';
import { ProductPreview } from 'src/components/ProductPreview';

interface Props {
  price?: IFuturePrice | null;
}

const getColor = (pricePrevious: number, priceNew: number) => {
  const nextPrice = priceNew - pricePrevious;
  if (nextPrice > 0) return 'green';
  if (nextPrice < 0) return 'red';
  return 'teal';
};

export const FuturePrice: React.FunctionComponent<Props> = ({ price }) => (
  <div>
    {price?.lines?.map(line => (
      <Box key={line.product.code} px={2} py={1}>
        <div>
          <Link
            target="_blank"
            href={`${process.env.REACT_APP_PUBLIC_PORTAL_HOST}/products/${line.product.code}`}
          >
            {line.product.code}
          </Link>{' '}
          {line.product.vendorCode} {line.product.name}
        </div>
        <div>
          <span title="Предыдущая цена">{line.pricePrevious}₽</span>→{' '}
          <span title="Новая цена">{line.priceNew}₽</span>{' '}
          <b style={{ color: getColor(line.pricePrevious, line.priceNew) }}>
            {(line.priceNew - line.pricePrevious).toFixed(2)}₽
          </b>{' '}
          ({line.changePercent}%)
        </div>
      </Box>
    ))}
  </div>
);
